import React from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import {
  FluentProvider,
  webLightTheme,
  webDarkTheme
} from "@fluentui/react-components";

const uiSchema = {
  TipoParte: { "ui:widget": "hidden" },
  TipoParteDescripcion: { "ui:widget": "hidden" },
};

export default function JsonSchemaFormFluent({ schema, formData, onChange }) {
  const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

  if (!schema || !schema.properties) {
    return <p style={{ color: "#999" }}>Schema no disponible</p>;
  }

  return (
    <FluentProvider theme={isDark ? webDarkTheme : webLightTheme}>
      <div className="json-schema-form-aligned" style={{ padding: 0, borderRadius: 8 }}>
        <style>{`
           /* Sfondo generale */
          .json-schema-form-aligned {
            background-color: #000 !important;
          }
          /* Stili per allineamento form */
          .json-schema-form-aligned .form-group,
          .json-schema-form-aligned .field {
            display: flex !important;
            align-items: flex-start !important;
            margin-bottom: 2px !important;

          }
          
          .json-schema-form-aligned label.control-label {
            display: inline-block !important;
            min-width: 200px !important;
            max-width: 200px !important;
            width: 200px !important;
            flex-shrink: 0 !important;
            text-align: left !important;
            margin: 0 !important;
            color: var(--blanco, #fff) !important;
          }
          
          .json-schema-form-aligned .form-control,
          .json-schema-form-aligned input,
          .json-schema-form-aligned select,
          .json-schema-form-aligned textarea {
            flex: 1 !important;
            min-width: 400px !important;
          }
          
          /* Gestione checkbox e radio */
          .json-schema-form-aligned .checkbox,
          .json-schema-form-aligned .radio {
            display: flex !important;
            align-items: center !important;
          }
          
          .json-schema-form-aligned .checkbox label,
          .json-schema-form-aligned .radio label {
            min-width: auto !important;
            max-width: none !important;
            width: auto !important;
            padding-top: 0 !important;
          }
          
          /* Nested objects (Params) */
          .json-schema-form-aligned fieldset {
            border: 1px solid var(--gray, #444) !important;
            border-radius: 4px !important;
            padding: 4px !important;
            margin-top: 2px !important;
          }
          
          .json-schema-form-aligned legend {
            color: var(--lightblue, #00bcd4) !important;
            font-weight: bold !important;
            padding: 0 2px !important;
          }
          
          /* Fix per required asterisk */
          .json-schema-form-aligned .required {
            color: var(--lightblue, #00bcd4) !important;
          }
          
          /* Help text */
          .json-schema-form-aligned .field-description,
          .json-schema-form-aligned .help-block {
            margin-left: 210px !important;
            margin-top: -8px !important;
            margin-bottom: 2px !important;
            color: #999 !important;
            font-size: 0.9em !important;
          }
          
          /* Error messages */
          .json-schema-form-aligned .error-detail,
          .json-schema-form-aligned .text-danger {
            margin-left: 210px !important;
            color: #ff4444 !important;
          }
        `}</style>
        <Form
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          onChange={onChange}
          validator={validator}
          liveValidate
          noValidate
          showErrorList={false}
        >
          {/* nessun pulsante interno */}
          <></>
        </Form>
      </div>
    </FluentProvider>
  );
}